export const SECONDARY_LEVELS = ["1", "2", "3"];

export const isSecondaryLevel = (level) => SECONDARY_LEVELS.includes(String(level));

export const isVisibleLevel = (levelId) => true;

export const LEVEL_LABELS = {
  1: "الصف الثاني الثانوي (بكالوريا)",
  2: "الصف الثالث الثانوي (إحصاء)",
  3: "الصف الثالث الثانوي (رياضة)",
};

export const LEVEL_IMAGES = {
  1: "/images/2sec.png",
  2: "/images/3sec-1.png",
  3: "/images/3sec-2.png",
};

export const getLevelLabel = (levelId, fallback = "") =>
  LEVEL_LABELS[Number(levelId)] || fallback || `المستوى ${levelId}`;
